import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Button } from 'shared';
import { userDataSelector } from 'store/slices/user-slice';
import { getDomainAndSubdomain } from 'utils/domain';
import RootModalLayout from '../RootModalLayout';
import classes from '../SharedModal.module.scss';

interface NoApiImplementedModalProps {
  isModalOpen?: boolean;
  onClose?: () => void;
}

export const NoApiImplementedModal: React.FC<NoApiImplementedModalProps> = ({ isModalOpen, onClose }) => {
  const navigate = useNavigate();
  const user = useSelector(userDataSelector);

  const [internalOpen, setInternalOpen] = useState(false);
  const { subdomain } = getDomainAndSubdomain();
  const isPoolsPageAvailable =
    subdomain === 'cryptohall24-duerr' ||
    subdomain === 'cryptohall24-quetta' ||
    subdomain === 'pantheon' ||
    subdomain === 'pantheon-aus' ||
    subdomain === 'hearst' ||
    subdomain === 'avatron' ||
    subdomain === 'paymine' ||
    subdomain === 'cryptotech' ||
    subdomain === 'higgs';

  const open = isModalOpen ?? internalOpen;

  useEffect(() => {
    if (isModalOpen !== undefined) return;

    if (!user) {
      setInternalOpen(false);
      return;
    }

    if (!user.hasNicehashKey && !user.hasViaBtcKey && isPoolsPageAvailable) {
      setInternalOpen(true);
    } else {
      setInternalOpen(false);
    }
  }, [user, isPoolsPageAvailable, isModalOpen]);

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      setInternalOpen(false);
    }
  };

  const navigateToPools = () => {
    navigate('/pools');
    handleClose();
  };

  if (!open) return null;

  return (
    <RootModalLayout onClose={handleClose} title='No Pool connected via API!'>
      <section className={classes.mainContent}>
        <Typography>
          Transparency is at the core of what we do. With us, you only pay for what you actually use. To track your
          power usage, please connect your mining pool via API. We&apos;ve noticed that you haven&apos;t connected a
          pool yet — make sure to do so to ensure you&apos;re billed only for what you consume.
        </Typography>
      </section>

      <section className={classes.modalFooter}>
        <Button variant='contained' onClick={navigateToPools}>
          Connect Pool
        </Button>
      </section>
    </RootModalLayout>
  );
};
